<template>
  <div class="card shadow mb-4">
    <!-- Card Header -->
    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
      <h6 class="m-0 font-weight-bold">{{ $t('Consumption_of_produced_energy') }}</h6>
      <i class="fas fa-info-circle" data-toggle="tooltip" data-placement="top" :title="$t('comparison_tooltip_consumption')"></i>
    </div>
    <!-- End of Card Header -->

    <!-- Card Body -->
    <div class="card-body">
      <div class="row text-center">
        <div class="col-md-6 text-center">
          <p v-if="current_page == 'Comparison'">{{ datetimes[0] }}</p>
          <ConsumptionDetailsDonut :id="parseInt(0)" :data="data[0]"></ConsumptionDetailsDonut>
        </div>
        <div class="col-md-6 text-center">
          <p v-if="current_page == 'Comparison'">{{ datetimes[1] }}</p>
          <ConsumptionDetailsDonut :id="parseInt(1)" :data="data[1]"></ConsumptionDetailsDonut>
        </div>
      </div>
    </div>
    <!-- End of Card Body -->
  </div>
</template>

<script>
import ConsumptionDetailsDonut from './ConsumptionDetailsDonut.vue'

export default {
  name: 'ConsumptionDetailsComparison',
  components:{
    ConsumptionDetailsDonut
  },
  data () {
    return {
      datetimes: []
    }
  },
  mounted(){
    for(let i=0; i<this.data.length; i++)
      this.datetimes.push(null)
  },
  methods: {
    set_values: function(){
      const datetimes = [this.datetime1, this.datetime2] //this.$store.getters.datetimes
      for (let i=0; i<datetimes.length; i++){
        this.datetimes.push(null)
        if (datetimes[i] == null) this.datetimes[i] = ''
        const datetime = moment(datetimes[i])
        if (this.range == 'day') this.datetimes[i] = moment(datetime).format('DD MMM YYYY')
        else if (this.range == 'week') this.datetimes[i] = moment(datetime).format('DD') +'-' + moment(datetime).add(6, "days").format('DD MMM YYYY')
        else if (this.range == 'month') this.datetimes[i] = moment(datetime).format('MMM YYYY')
      }
    },
  },
  watch:{
    current_lang: function(){
      this.set_values()
    },
    data: function(){
      this.set_values()
    }
  },
  computed: {
    data: function(){
      return this.$store.getters.data_consumption
    },
    range: function(){
      return this.$store.getters.selected_range
    },
    datetime1: function(){
      return this.$store.getters.datetime1
    },
    datetime2: function(){
      return this.$store.getters.datetime2
    },
    current_page: function(){
      return this.$route.name
    },
    current_lang: function(){
      return this.$i18n.locale
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
